import styled from '@emotion/styled/macro';
import { transparentize } from 'polished';
import React from 'react';
import { Variables } from '../base';

const TagContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
`;

const Tag = styled.span`
    display: inline-block;
    color: ${Variables.Colors.i20};
    background-color: ${transparentize(0.75, Variables.Colors.i10)};
    border-radius: ${Variables.Rounded.medium};
    padding: 2px 8px;
    font-size: 14px;
    white-space: nowrap;
`;

const EmptyState = styled.span`
    color: ${Variables.Colors.n50};
    font-style: italic;
    font-size: 14px;
`;

interface ICategoryTagsProps {
    categories?: string[];
}

/**
 * CategoryTags component for displaying message categories as colored tags.
 * Uses larger font size for better readability.
 */
export const CategoryTags: React.FC<ICategoryTagsProps> = ({ categories }) => {
    if (!categories || categories.length === 0) {
        return <EmptyState>—</EmptyState>;
    }

    return (
        <TagContainer>
            {categories.map((item, index) => (
                <Tag key={`${item}-${index}`}>
                    {item}
                </Tag>
            ))}
        </TagContainer>
    );
};

